
















import { defineComponent } from '@vue/composition-api';
import svgCom from '@/components/Svg/index';

export default defineComponent({
  name: 'CardModel',
  components: {
    svgCom,
  },
  props: {
    cardData: {
      type: Array,
      defalut: []
    },
    cardType: {
      type: String,
      defalut: 'fourItem'
    }
  },
  setup() {
  },
});
